import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_any_of_the_following_safety_measures_in_place_13'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_any_of_the_following_safety_measures_in_place_13',
  name: 'Does the facility have any of the following safety measures in place related to hot work?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'HOT_WORK_IS_PERFORMED_IN_AN_APPROVED_DESIGNATED_AREA_WHEN_POSSI',
      text: 'Hot work is performed in an approved designated area when possible',
      externalIds: [
        {
          id: 'hs-wor-11',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HOT_WORK_OUTSIDE_OF_AN_APPROVED_DESIGNATED_AREA_REQUIRES_A_PERM',
      text: 'Hot work outside of an approved designated area requires a permit',
      externalIds: [
        {
          id: 'hs-wor-12',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'APPROPRIATE_DISTANCE_OR_OTHER_CONTROLS_E_G_FIRE_WATCH_ARE_IN_PL',
      text: 'Appropriate distance or other controls (e.g. fire watch) are in place to prevent ignition of combustible materials',
      externalIds: [
        {
          id: 'hs-wor-13',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'AREAS_WHERE_HOT_WORK_IS_CONDUCTED_IS_APPROPRIATELY_VENTILATED',
      text: 'Areas where hot work is conducted is appropriately ventilated',
      externalIds: [
        {
          id: 'hs-wor-14',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HOT_WORK_EQUIPMENT_IS_INSPECTED_PRIOR_TO_USE',
      text: 'Hot work equipment is inspected prior to use',
      externalIds: [
        {
          id: 'hs-wor-15',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-wor-16',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'HOT_WORK_IS_PERFORMED_IN_AN_APPROVED_DESIGNATED_AREA_WHEN_POSSI',
                'HOT_WORK_OUTSIDE_OF_AN_APPROVED_DESIGNATED_AREA_REQUIRES_A_PERM',
                'APPROPRIATE_DISTANCE_OR_OTHER_CONTROLS_E_G_FIRE_WATCH_ARE_IN_PL',
                'AREAS_WHERE_HOT_WORK_IS_CONDUCTED_IS_APPROPRIATELY_VENTILATED',
                'HOT_WORK_EQUIPMENT_IS_INSPECTED_PRIOR_TO_USE',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-wor-10',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 16140,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
